exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".disabled-alpha[data-v-1ef9a701]{opacity:.15;color:#fff!important;cursor:not-allowed}.disabled-alpha.btn-black[data-v-1ef9a701]{opacity:.7;color:initial!important}.btn-transparent.disabled-alpha[data-v-1ef9a701],.btn-white.disabled-alpha[data-v-1ef9a701]{color:inherit!important}.material-icons-outlined[data-v-1ef9a701]{vertical-align:top}", ""]);

// exports
